import { render, staticRenderFns } from "./EnrolamientoCliente.vue?vue&type=template&id=b5b0e2f2&scoped=true&"
import script from "./EnrolamientoCliente.vue?vue&type=script&lang=ts&"
export * from "./EnrolamientoCliente.vue?vue&type=script&lang=ts&"
import style0 from "./EnrolamientoCliente.vue?vue&type=style&index=0&id=b5b0e2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b0e2f2",
  null
  
)

export default component.exports